import {
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@material-ui/core';
import React from 'react';
import moment from 'moment';
import SortableTableCell from '../../../../components/atom/SortableTableCell';
import TablePager from '../../../../components/atom/TablePager';
import { formatMoney } from '../../../../utils';

const PayoutsTable = ({
    page,
    setPage,
    pageSize,
    setPageSize,
    payoutsData,
    sort,
    sortDir,
    setSorting,
    groupActivities
}) => {
    return (
        <Grid item xs={12}>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            {!groupActivities && (
                                <SortableTableCell
                                    arrow={
                                        sort === 'booking_item_tickets.booking_items.booking_id'
                                            ? sortDir
                                            : ''
                                    }
                                    onClick={() =>
                                        setSorting('booking_item_tickets.booking_items.booking_id')
                                    }
                                >
                                    Booking id
                                </SortableTableCell>
                            )}
                            {!groupActivities && (
                                <SortableTableCell
                                    arrow={sort === 'created_at' ? sortDir : ''}
                                    onClick={() => setSorting('created_at')}
                                >
                                    Booked on
                                </SortableTableCell>
                            )}
                            <SortableTableCell
                                arrow={sort === 'name' ? sortDir : ''}
                                onClick={() => setSorting('name')}
                            >
                                Fee type
                            </SortableTableCell>
                            <SortableTableCell
                                arrow={sort === 'companies.name' ? sortDir : ''}
                                onClick={() => setSorting('companies.name')}
                            >
                                Account to
                            </SortableTableCell>
                            {!groupActivities && (
                                <SortableTableCell
                                    arrow={sort === 'agent' ? sortDir : ''}
                                    onClick={() => setSorting('agent')}
                                >
                                    Agent
                                </SortableTableCell>
                            )}
                            <SortableTableCell
                                arrow={sort === 'net' ? sortDir : ''}
                                onClick={() => setSorting('net')}
                            >
                                Net USD
                            </SortableTableCell>
                            <SortableTableCell
                                arrow={sort === 'tax' ? sortDir : ''}
                                onClick={() => setSorting('tax')}
                            >
                                Tax
                            </SortableTableCell>
                            <SortableTableCell
                                arrow={
                                    sort === 'booking_item_tickets.booking_items.activities.name'
                                        ? sortDir
                                        : ''
                                }
                                onClick={() =>
                                    setSorting('booking_item_tickets.booking_items.activities.name')
                                }
                            >
                                Activity name
                            </SortableTableCell>
                            {!groupActivities && (
                                <SortableTableCell
                                    arrow={
                                        sort === 'booking_item_tickets.booking_items.status'
                                            ? sortDir
                                            : ''
                                    }
                                    onClick={() =>
                                        setSorting('booking_item_tickets.booking_items.status')
                                    }
                                >
                                    Status
                                </SortableTableCell>
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {payoutsData?.bookingPayouts.map(payout => (
                            <TableRow key={payout.id}>
                                {!groupActivities && <TableCell>{payout.booking_id}</TableCell>}
                                {!groupActivities && (
                                    <TableCell>
                                        {moment
                                            .utc(payout.createdAt)
                                            .format('MMMM Do YYYY, h:mm a')}
                                    </TableCell>
                                )}
                                <TableCell>{payout.feeType}</TableCell>
                                <TableCell>{payout.accountTo}</TableCell>
                                {!groupActivities && <TableCell>{payout.agent || '-'}</TableCell>}
                                <TableCell align="right" style={{ whiteSpace: 'nowrap' }}>
                                    {formatMoney(payout.netPayout)}
                                </TableCell>
                                <TableCell align="right" style={{ whiteSpace: 'nowrap' }}>
                                    {formatMoney(payout.tax)}
                                </TableCell>
                                <TableCell>{payout.activity || '-'}</TableCell>
                                {!groupActivities && <TableCell>{payout.status || '-'}</TableCell>}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Grid container justifyContent="flex-end">
                <TablePager
                    total={payoutsData?.total}
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                />
            </Grid>
        </Grid>
    );
};

export default PayoutsTable;
